export const Base_url ={
    BASE_URL :'http://localhost:5090',
    api_sendMail: 'api/send-email'
};

export const analytics ={
    gaId :'4B6YF416BJ',
};